import { Component } from '@angular/core';

@Component({
  selector: 'app-signup-layout',
  templateUrl: './signup-layout.component.html',
  styleUrls: ['./signup-layout.component.scss'],
  standalone: false,
})
export class SignupLayoutComponent {}
